import { postApi } from "../../../../../../../api/Setters/post.api";

export async function takeBunkeringData({
  ship,

  start,
  end,

  averageTags = [],
  latestTags = [],

  title,

  emails,

  metadata,

  save = true
}) {
  //   if (!ship || !start || !end) return null;

  const payload = {
    start,
    end,

    source: ship,

    averageTags,
    latestTags,

    title,

    emails,

    metadata,

    save
  };

  try {
    const response = await postApi("records/abstract/report", payload);
    console.log("Sending bunkering data:", response);

    return response?.data;
  } catch (error) {
    console.error("Error fetching bunkering data:", error);
    return null;
  }
}

export const safeToISOString = (date) => {
  console.log({ date }, "safetoiso");

  const toLocalISOStringPlus3 = (d) => {
    // Add 3 hours (in milliseconds)
    const adjusted = new Date(d.getTime() + 3 * 60 * 60 * 1000);

    const pad = (n) => String(n).padStart(2, "0");

    const year = adjusted.getFullYear();
    const month = pad(adjusted.getMonth() + 1);
    const day = pad(adjusted.getDate());
    const hours = pad(adjusted.getHours());
    const minutes = pad(adjusted.getMinutes());
    const seconds = pad(adjusted.getSeconds());

    // Keep the timezone offset from the system
    const tzOffset = -adjusted.getTimezoneOffset(); // in minutes
    const sign = tzOffset >= 0 ? "+" : "-";
    const offsetHours = pad(Math.floor(Math.abs(tzOffset) / 60));
    const offsetMinutes = pad(Math.abs(tzOffset) % 60);

    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}${sign}${offsetHours}:${offsetMinutes}`;
  };

  if (date instanceof Date && !isNaN(date)) {
    return toLocalISOStringPlus3(date);
  }

  try {
    const parsed = new Date(date);
    return isNaN(parsed) ? null : toLocalISOStringPlus3(parsed);
  } catch {
    return null;
  }
};
